import { render } from "./WordCloudChart.vue?vue&type=template&id=03f7455a&scoped=true"
import script from "./WordCloudChart.vue?vue&type=script&lang=js"
export * from "./WordCloudChart.vue?vue&type=script&lang=js"

import "./WordCloudChart.vue?vue&type=style&index=0&id=03f7455a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f7455a"]])

export default __exports__